import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian.js";
import persian_fa from "react-date-object/locales/persian_fa.js";

// Same Jalali calendar/locale combination used by Calendarr.js/Week.js
// elsewhere in the app, so challenge date labels look identical.
export function formatJalali(isoDateStr, format = "DD MMMM") {
  if (!isoDateStr) return "";
  return new DateObject({ date: new Date(isoDateStr), locale: persian_fa })
    .setCalendar(persian)
    .format(format);
}

export function todayIsoDate() {
  return new Date().toISOString().substring(0, 10);
}
